import userService from "@/endpoints/userService";

const LOGOUT_LOCK_KEY = "__ai_assistant_logout_in_progress__";

export const triggerAssistantAuthLogout = async () => {
  if (typeof window === "undefined") return;
  if (window[LOGOUT_LOCK_KEY]) return;

  window[LOGOUT_LOCK_KEY] = true;
  try {
    await userService.auth.logout();
  } catch (error) {
    console.warn("[AI Assistant] Forced logout failed", error);
  } finally {
    window.setTimeout(() => {
      window[LOGOUT_LOCK_KEY] = false;
    }, 1500);
  }
};

